import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { DotCmsFacade } from 'src/app/extensions/dot-cms/facades/dot-cms.facade';
import { CustomDotCmsContentlet } from 'src/app/extensions/dot-cms/models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from 'src/app/extensions/dot-cms/models/dot-cms-content-types-component.model';
import { setupIntersectionObserver } from 'src/app/extensions/dot-cms/utils/dot-cms-utils';

import { GoogleTagManagerFacade } from 'ish-core/facades/gtm.facade';

@Component({
  selector: 'custom-dot-cms-banner-video',
  templateUrl: './dot-cms-banner-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsBannerVideoComponent implements DotCmsContentTypeComponent, OnChanges, OnDestroy {
  @Input() identifier: string;
  contentlet$: Observable<CustomDotCmsContentlet>;
  animationTriggered$ = new ReplaySubject<boolean>(1);
  private intersectionObserver: IntersectionObserver;
  private destroy$ = new Subject<void>();
  triggerCount = 1;
  constructor(
    private dotCmsFacade: DotCmsFacade,
    private elementRef: ElementRef,
    private gtmFacade: GoogleTagManagerFacade
  ) {}

  ngOnChanges(): void {
    this.contentlet$ = this.dotCmsFacade.getContentletByIdentifier$(this.identifier);
    this.intersectionObserver = setupIntersectionObserver(this.elementRef.nativeElement, this.animationTriggered$);
    this.contentlet$.pipe(takeUntil(this.destroy$)).subscribe(contentlet => {
      this.gtmFacade.setupIntersectionObserverForGTMEvent(
        this.elementRef.nativeElement,
        [contentlet],
        this.triggerCount,
        'view_promotion'
      );
    });
  }

  getVideoHeight$(contentlet: CustomDotCmsContentlet): Observable<string> {
    return this.dotCmsFacade.getVideoHeight(contentlet);
  }

  buildVideoSrc(videoKey: string) {
    return this.dotCmsFacade.generateVideoURIFromImageKey(this.identifier, videoKey);
  }

  bannerVideoWidth(contentlet: CustomDotCmsContentlet): string {
    if (contentlet?.maxWidth) {
      return 'full-width-video';
    }
    return;
  }
  ngOnDestroy() {
    this.intersectionObserver?.disconnect();
    this.destroy$.next();
    this.destroy$.complete();
  }
}
